"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _g;
var VideoMeeting = function VideoMeeting(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 43 26"
  }, props), _g || (_g = /*#__PURE__*/_react.default.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group-4",
    transform: "translate(-1.490560, 1.909831)",
    stroke: "currentColor",
    strokeWidth: "2"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    id: "Rectangle-Copy",
    x: "8.9905599",
    y: "0",
    width: "28",
    height: "18.0901693",
    rx: "1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.10091146,18.1119792 L36.8929036,18.1119792 L42.7347544,21.025705 C43.2289763,21.2722069 43.429793,21.8726821 43.1832911,22.366904 C43.0140748,22.706173 42.6675507,22.9205729 42.2884233,22.9205729 L4.03321084,22.9205729 C3.48092609,22.9205729 3.03321084,22.4728577 3.03321084,21.9205729 C3.03321084,21.5498692 3.23828149,21.2095816 3.56604689,21.0364022 L9.10091146,18.1119792 L9.10091146,18.1119792 Z",
    id: "Rectangle"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.0078125,6.26041667 L26.0078125,9.26041667",
    id: "Line",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.0078125,9.29664376 L21.0078125,12.2966438",
    id: "Line-Copy",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.9905599,6.34627279 L20.9905599,12.1773275",
    id: "Line-2",
    strokeLinecap: "round"
  })))));
};
var _default = exports.default = VideoMeeting;